//export const apiBaseUrl = "http://localhost:9090";
export const apiBaseUrl = "https://api.pitchplaylists.com";
//export const apiBaseUrl = "https://staging-api.pitchplaylists.com";

// Derive frontend base URL from API base URL
export const getFrontendBaseUrl = (): string => {
  if (apiBaseUrl.includes('localhost')) {
    return typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000';
  } else if (apiBaseUrl.includes('staging-api.pitchplaylists.com')) {
    return 'https://staging.pitchplaylists.com';
  } else if (apiBaseUrl.includes('api.pitchplaylists.com')) {
    return 'https://pitchplaylists.com';
  }
  // Default fallback
  return 'https://pitchplaylists.com';
};

export const frontendBaseUrl = getFrontendBaseUrl();

export const stripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY!;
export const paypalClientId: string =
  process.env.REACT_APP_PAYPAL_CLIENT_ID || "";
